module.exports = __webpack_public_path__ + "static/media/logo_avatar.fbdc0d06.png";